import { MenuItem, Select } from "@mui/material";
import * as React from "react";

export default function SelectMenu({ menu = [] }) {
  const [selectedValue, setSelectedValue] = React.useState(menu[0] || "None");

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <Select
      size="small"
      value={selectedValue}
      onChange={handleChange}
      sx={{ minWidth: 100 }}
    >
      {menu.map((item, index) => (
        <MenuItem key={index} value={item}>
          {item}
        </MenuItem>
      ))}
    </Select>
  );
}